import { render, staticRenderFns } from "./CourseManagementPage.vue?vue&type=template&id=051ce48d&scoped=true&"
import script from "./CourseManagementPage.vue?vue&type=script&lang=js&"
export * from "./CourseManagementPage.vue?vue&type=script&lang=js&"
import style0 from "./CourseManagementPage.vue?vue&type=style&index=0&id=051ce48d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ce48d",
  null
  
)

export default component.exports